<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<!-- <breadcrumbs :breadcrumbs="page.breadcrumbs" :class="page.headingImage ? '' : 'no-slider'" /> -->

		<main-content
			:title="page.title || page.header"
			:subtitle="page.subtitle"
			:content="page.content"
			:introduction-content="page.introductionContent"
		>
			<template #bgImage>
				<picture>
					<source srcset="/images/bg-index.webp" type="image/webp" />
					<source srcset="/images/bg-index.jpg" />
					<img class="fade-image" src="/images/bg-index.webp" alt="Booking benefits" loading="lazy" />
				</picture>
			</template>
		</main-content>

		<section class="main-content review-section background-light">
			<review-card v-for="review in reviews" :key="review.ID" :item="review" class="row review-row" />
		</section>

		<contentblocks
			v-if="page && page.contentblocks && page.contentblocks.length"
			:contentblocks="page.contentblocks"
			:content-blocks-content="page.sectionContentblocksContent"
			:content-blocks-subtitle="page.sectionContentblocksTitle"
		/>

		<frequently-asked-questions
			v-if="page && page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:subtitle="page.frequentlyAskedQuestion.subtitle"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
		<pre-footer
			v-if="page && page.footerSection && page.footerSection.length"
			:footer-section="page.footerSection[0]"
		/>
		<newsletter
			v-if="page && page.showNewsletter"
			:formid="defaults[locale].newsletter.mailChimpID"
			:link="defaults[locale].newsletter.mailChimpLink"
			:header="defaults[locale].newsletter.title"
			:content="defaults[locale].newsletter.content"
			:button="defaults[locale].newsletter.button"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();
const config = useRuntimeConfig();

await fetchPage();
await fetchDefaults();

const { data: reviews } = await useWebsiteFetch('reviews', {
	query: { language: locale.value },
	key: `${locale.value}/reviews`,
});

const getReviewTotalAverage = () => {
	const sum = reviews.value
		.filter((review) => review.rating)
		.reduce((total, current) => total + parseInt(current.rating, 10), 0);

	return sum / reviews.value.length;
};

const currentUrl = config.public.siteUrl;

useHead({
	script: [
		{
			type: 'application/ld+json',
			innerHTML: JSON.stringify({
				'@context': 'http://schema.org',
				'@type': 'AggregateRating',
				'@id': `${currentUrl}#aggregaterating`,
				bestRating: 10,
				ratingValue: getReviewTotalAverage(),
				ratingCount: reviews.value.length,
				itemReviewed: {
					'@id': `${currentUrl}#hotel`,
				},
			}),
		},
	],
});
</script>

<style lang="scss" scoped>
.review-row {
	margin: 0 auto 25px;
	max-width: 900px;
}
</style>
